import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../components/Index'
import Starnote from '../components/Starnote'
import Manage from '../components/Manage'
import Login from '../components/Login'
import Post from '../components/Post'
import About from "../components/footers/About"
import Newbie from "../components/footers/Newbie"


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/@:author/:permlink',
    name: 'starnote',
    component: Starnote
  },
  {
    path: '/manage',
    name: 'manage',
    component: Manage
  },
  {
    path: '/post',
    name: 'post',
    component: Post
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/newbie',
    name: 'newbie',
    component: Newbie
  },
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
